export default __webpack_public_path__ + "static/media/actual-hours.76a3dfbb.svg";